import { num } from "./formato.ts";

export type RascunhoReceita = {
  animal: string;
  tutor: string;
  cpf: string;
  peso: string;
  itens: { farmaco: string; pos: string; controle?: string }[];
};

/** Quais campos exigidos pela norma o rascunho já tem. A espécie sempre vem do seletor. */
export function camposPreenchidos(rx: RascunhoReceita): Record<string, boolean> {
  return {
    animal: !!rx.animal.trim(),
    especie: true,
    tutor: !!rx.tutor.trim(),
    cpf: rx.cpf.replace(/\D/g, "").length === 11,
    peso: !!num(rx.peso),
    itens: rx.itens.length > 0,
  };
}

export function checarReceita(campos: { t: string; chave?: string }[], rx: RascunhoReceita) {
  const ok = camposPreenchidos(rx);
  const itens = campos.map((c) => ({ ...c, ok: !!(c.chave && ok[c.chave]) }));
  return { itens, preenchidos: itens.filter((i) => i.ok).length, total: campos.length };
}
